import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddVehicleLayer from "../../components/vehicles/AddVehicleLayer";



const AddVehiclePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Vehicle" />

        {/* AddUserLayer */}
        <AddVehicleLayer />


      </MasterLayout>
    </>
  );
};

export default AddVehiclePage;
